<!-- AMPLITUDE CHART COMPONENT - PRODUCTION VERSION -->
<div
  class="amplitude-chart-wrapper"
  [class.amplitude-chart-wrapper--compact]="isCompactScreen"
>
  <!-- CHART HEADER WITH CONTROLS -->
  <div class="chart-header">
    <div class="header-left">
      <h2 class="chart-title">Live streaming Alerts</h2>

      <span class="device-info">
        {{ getDeviceInfo(macId).floor }} - {{ getDeviceInfo(macId).room }}
        <b>Device:</b> {{ getDeviceInfo(macId).deviceId }}
        <!-- <b>Mac:</b> {{getDeviceInfo(macId).macId}} -->
        <ng-container *ngFor="let card of sensorCards">
          <span class="sensor-text">
            <b>{{ card.label }}:</b>
            <span *ngIf="card.icon === 'wifi'" class="wifi-signal-inline" [attr.title]="card.value || 'WiFi signal'">
              <span class="wifi-signal-bars">
                <span
                  *ngFor="let i of [1, 2, 3, 4, 5]"
                  [class]="'wifi-bar wifi-bar--' + i + (i <= (card.signalBars || 0) ? ' wifi-bar--active' : '')"
                ></span>
              </span>
              <!-- <span class="wifi-signal-text" *ngIf="card.value">{{ card.value }}</span> -->
            </span>
            <span *ngIf="card.icon !== 'wifi'">{{ card.value }}</span>
          </span>
        </ng-container>
      </span>
    </div>
  </div>


   <!-- UI STATE BANNER -->
  <div
    class="ui-state-banner"
    [class.ui-state--normal]="getCurrentUiState() === 'Normal'"
    [class.ui-state--monitoring]="getCurrentUiState() === 'Monitoring'"
    [class.ui-state--critical]="getCurrentUiState() === 'Critical'"
  >
    <div class="ui-state-main">
      <div class="ui-state-badge">
        {{ getCurrentUiState() | uppercase }}
      </div>

      <div class="ui-state-content">
        <div class="ui-state-message">
          {{ getCurrentUiMessage() }}
        </div>

        <div class="ui-state-phase">
          Phase: {{ getCurrentEscalationPhase() }}
        </div>
      </div>
    </div>
  </div>

  <div class="chart-legend">
    <div class="legend-item" *ngIf="hasType('C-diff Positive Toxigenic')">
      <span class="legend-color" style="background: #ff3300"></span>
      <span class="legend-label">C-diff Positive Toxigenic</span>
    </div>

    <div class="legend-item" *ngIf="hasType('C-diff Positive non-Toxigenic', 'C-diff Positive Non-Toxigenic')">
      <span class="legend-color" style="background: #eab308"></span>
      <span class="legend-label">C-diff Positive Non-Toxigenic</span>
    </div>

    <div class="legend-item" *ngIf="hasType('C-diff Negative')">
      <span class="legend-color" style="background: #4caf50"></span>
      <span class="legend-label">C-diff Negative</span>
    </div>

    <div class="legend-item" *ngIf="hasType('Cleaning', 'Cleaning Agent')">
      <span class="legend-color" style="background: #9333ea"></span>
      <span class="legend-label">Cleaning</span>
    </div>

    <div class="legend-item" *ngIf="hasType('Deep Clean')">
      <span class="legend-color" style="background: #417399"></span>
      <span class="legend-label">Deep Clean</span>
    </div>

    <div class="legend-item" *ngIf="hasTypeKey('ammonia')">
      <span class="legend-color" [style.background]="getLegendColor('ammonia')"></span>
      <span class="legend-label">{{ getLegendLabel('ammonia') }}</span>
    </div>

    <div class="legend-item" *ngIf="hasTypeKey('methanol')">
      <span class="legend-color" [style.background]="getLegendColor('methanol')"></span>
      <span class="legend-label">{{ getLegendLabel('methanol') }}</span>
    </div>

    <div class="legend-item" *ngIf="hasTypeKey('propanol')">
      <span class="legend-color" [style.background]="getLegendColor('propanol')"></span>
      <span class="legend-label">{{ getLegendLabel('propanol') }}</span>
    </div>

    <div class="legend-item" *ngIf="hasTypeKey('toluene')">
      <span class="legend-color" [style.background]="getLegendColor('toluene')"></span>
      <span class="legend-label">{{ getLegendLabel('toluene') }}</span>
    </div>

    <div class="legend-item" *ngIf="hasTypeKey('isopropyl-alcohol')">
      <span class="legend-color" [style.background]="getLegendColor('isopropyl-alcohol')"></span>
      <span class="legend-label">{{ getLegendLabel('isopropyl-alcohol') }}</span>
    </div>

    <div class="legend-item" *ngIf="hasTypeKey('acetone')">
      <span class="legend-color" [style.background]="getLegendColor('acetone')"></span>
      <span class="legend-label">{{ getLegendLabel('acetone') }}</span>
    </div>

    <div class="legend-item" *ngIf="hasType('Unknown')">
      <span class="legend-color" style="background: #9e9e9e"></span>
      <span class="legend-label">Unknown</span>
    </div>
  </div>

  <!-- MAIN CHART AREA -->
  <div class="chart-container">
    <!-- LEFT Y-AXIS (Amplitude) -->
        <div class="y-axis y-axis--left">
          <div class="y-axis__ticks">

      <span
        class="tick"
        *ngFor="let tick of getAmplitudeTicks()"
      >
        {{ tick.toFixed(1) }}
      </span>

    </div>
      
    <div class="y-axis__label">Amplitude</div>
    </div>

    <!-- CHART CANVAS -->
    <div class="chart-canvas">
      <div class="chart-scroll">
        <div class="chart-scroll-inner">
      <!-- GRID AND BARS -->
      <div class="chart-grid">
        <!-- Horizontal grid lines -->
        <div
          class="grid-line"
          *ngFor="let line of gridLines"
          [style.bottom.%]="line"
        ></div>

        <!-- Confidence line (follows bar tops) -->
        <svg
          class="confidence-line-svg"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
          *ngIf="getVisibleBarCount() > 1"
        >
          <polyline
            [attr.points]="getConfidenceLinePoints()"
            fill="none"
            stroke="#4a9eff"
            stroke-width="1"
            stroke-dasharray="2,2"
            opacity="0.6"
          ></polyline>
        </svg>

        <!-- Perfect round confidence dots (CSS circles — not stretched by SVG) -->
        <div class="confidence-dots-layer" *ngIf="getVisibleBarCount() > 0">
          <ng-container *ngFor="let bar of visibleBars">
            <div
              *ngIf="bar.visible"
              class="confidence-dot"
              [style.left.%]="getBarLeftPosition(bar) + getBarWidth() / 2"
              [style.top.%]="getConfidenceY(bar.confidence)"
            ></div>
          </ng-container>
        </div>

        <!-- Animated bars with ngbTooltip -->
        <div class="bars-container">
          <div
            *ngFor="let bar of visibleBars; let i = index"
            class="bar"
            [class.bar--visible]="bar.visible"
            [class.bar--alert]="bar.type === 'C-diff Positive Toxigenic'"
            [style.left.%]="getBarLeftPosition(bar)"
            [style.width.%]="getBarWidth()"
            [style.height.%]="bar.heightPercent"
            [style.background-color]="bar.color"
            [style.opacity]="bar.visible ? 1 : 0"
            [style.transform]="
              bar.visible ? 'translateY(0)' : 'translateY(20px)'
            "
            [attr.data-bar]="i + 1"
            [attr.data-type]="bar.type"
            [ngbTooltip]="tooltipTemplate"
            [tooltipContext]="{ bar: bar }"
            container="body"
            placement="top"
          ></div>
        </div>
      </div>

      <!-- X-AXIS DATE LABELS -->
      <div class="x-axis">
        <ng-container *ngFor="let bar of visibleBars; let i = index">
          <span
            class="x-tick"
            *ngIf="shouldShowXTick(i)"
            [class.x-tick--start]="i === 0"
            [class.x-tick--end]="isLastXTick(i)"
            [style.left.%]="bar.leftPosition + getBarWidth() / 2"
            [style.transform]="getXTickTransform(i)"
          >
            {{ formatTimeOnly(bar.timestamp) }}

            <div class="date-label">
              {{ formatDate(bar.timestamp) }}
            </div>
          </span>
        </ng-container>
      </div>
        </div>
      </div>
    </div>


    <div class="y-axis y-axis--right">
  <div class="y-axis__ticks">
    <span class="tick">100</span>
    <span class="tick">90</span>
    <span class="tick">80</span>
    <span class="tick">70</span>
    <span class="tick">60</span>
    <span class="tick">50</span>
    <span class="tick">40</span>
    <span class="tick">30</span>
    <span class="tick">20</span>
    <span class="tick">10</span>
    <span class="tick">0</span>
  </div>

  <div class="y-axis__label">Confidence (%)</div>
</div>
  </div>



 <div class="status-bar">
    <!-- UI STATE HISTORY -->

    <!-- <div class="state-history-card">
      <div class="state-history-header">
        <h3>Alert History</h3>

        <span class="history-count">
          {{ stateHistory.length }} transitions
        </span>
      </div>

      <div class="state-history-list">
        <div
          *ngFor="let item of stateHistory"
          class="state-history-item"
          [ngClass]="{
            'history-normal': item.state === 'Normal',
            'history-monitoring': item.state === 'Monitoring',
            'history-critical': item.state === 'Critical',
          }"
        >
          <div class="history-dot"></div>

          <div class="history-content">
            <div class="history-state">
              {{ item.state }}

              <span class="history-phase"> • {{ item.escalationPhase }} </span>
            </div>

            <div class="history-note">
              {{ item.note }}
            </div>
          </div>

          <div class="history-time">
            {{ item.timestamp | date: "MMM d, h:mm a" }}
          </div>
        </div>
      </div>
    </div> -->

    <span class="status-text">
      Status:
      <strong [class.status--running]="isRunning()">{{
        isRunning() ? "Running" : "Stopped"
      }}</strong>
    </span>
    <span class="status-text">
      Critical Alerts: <strong class="alert-count">{{ getAlertCount() }}</strong>
    </span>
    <span class="status-text">
      Events: <strong>{{ allBars.length }}</strong>
    </span>
  </div>

  <ng-template #tooltipTemplate let-bar="bar">
    <div class="chart-tooltip">
      <b>Location:</b> {{ getDeviceInfo(bar.deviceId).floor }}
      <br />
      <b>Inference:</b>
      {{ getInferenceText(bar.type) }}
      <br />
      <b>Confidence:</b> {{ (bar.confidence).toFixed(2) }}% <br />
      <b>Amplitude:</b> {{ bar.amplitude.toFixed(2) }}
      <br />
      <b>Time:</b> {{ bar.time }}
    </div>
  </ng-template>
</div>
